import './pages/show';



// WEBPACK FOOTER //
// ./modules/repositories/index.js